import { IObservableArray } from "mobx";
import { Configuration, RemoteVideoLayoutOptions } from "../common";

// TODO: unit test this logic
export function shiftLayoutsAfterPinning(
    layouts: IObservableArray<RemoteVideoLayoutOptions>,
    pinnedItem: RemoteVideoLayoutOptions,
    currentNumCols: number
) {
    const pinnedLayouts = layouts
        .filter((l) => l.isPinned)
        .map((l) => ({
            layout: l,
            // all pinned layouts should have gridX and gridY defined,
            // pinning can only happen through this current fn
            idx: l.gridX! + l.gridY! * currentNumCols,
        }))
        .sort((a, b) => a.idx - b.idx);

    let prevLayoutIdx = 0;
    for (const l of pinnedLayouts) {
        if (l.layout === pinnedItem) {
            continue;
        }

        if (l.idx === prevLayoutIdx) {
            // conflicting explicit grid layout, let's shift this one over
            if (l.layout.gridX === currentNumCols - 1) {
                l.layout.gridX = 0;
                l.layout.gridY = l.layout.gridY! + 1;
            } else {
                l.layout.gridX = l.layout.gridX! + 1;
            }
            l.idx += 1;
            prevLayoutIdx = l.idx;
        }
    }

    const nonPinnedLayoutsWithGridCoords = layouts.filter(
        (l) => !l.isPinned && l.gridX !== undefined && l.gridY !== undefined
    );
    for (const l of nonPinnedLayoutsWithGridCoords) {
        if (l.gridX! > currentNumCols) {
            // if this layout was set at a different breakpoint, just ignore it and bail out
            l.gridX = undefined;
            l.gridY = undefined;
        } else {
            const idx = l.gridX! + l.gridY! * currentNumCols;
            if (idx <= prevLayoutIdx) {
                // if we intersect with a previously laid out item, we must shift over
                const newIdx = prevLayoutIdx + 1;
                l.gridY = Math.floor(newIdx % currentNumCols);
                l.gridX = newIdx % currentNumCols;
                prevLayoutIdx = newIdx;
                if (Configuration.DEBUG) {
                    console.log(`Shifted over item from grid index ${idx} to ${newIdx}`, l);
                }
            }
        }
    }

    if (Configuration.DEBUG) {
        console.log("Layout after pinning:", JSON.parse(JSON.stringify(layouts)));
    }
}

export function shiftLayoutsAfterUnpinning(
    layouts: IObservableArray<RemoteVideoLayoutOptions>,
    item: RemoteVideoLayoutOptions,
    currentNumCols: number
) {
    // nothing yet
}
